import { isWeiXin } from './function'
const requestUrl = isWeiXin() ? location.pathname + 'api' : '/ndwnq';

export default {
  requestUrl
}
